import { useEffect, useState } from 'react'
import Icon from '../../../../../ui/Icon/Icon'
import HeroBannerTile from './HeroBannerTile'
import { useHeroBannerCarousel } from './useHeroBannerCarousel'
import gridStyles from './HeroCarousel.module.scss'

/**
 * Working Hero carousel frame with forced column count
 * (desktop preview = 4, mobile preview = 1).
 */
function HeroCarouselFrame({ banners, columns }) {
  const {
    index,
    count,
    trackBanners,
    trackStyle,
    viewportRef,
    goTo,
    goNext,
    goPrev,
    canLoop,
    isDragging,
    onPause,
    onResume,
    onFocusPause,
    onBlurResume,
  } = useHeroBannerCarousel(banners, { columns })

  const [hoverPauseOk, setHoverPauseOk] = useState(false)

  useEffect(() => {
    setHoverPauseOk(window.matchMedia('(hover: hover) and (pointer: fine)').matches)
  }, [])

  if (!banners.length) {
    return <p className="BannersSitePreview-Empty">Немає активних банерів для показу</p>
  }

  return (
    <div
      className={`${gridStyles.hero} ${gridStyles.heroReady}${canLoop ? ` ${gridStyles.heroInteractive}` : ''}`}
      aria-label="Прев'ю банерів на сайті"
      aria-roledescription="карусель"
      onMouseEnter={canLoop && hoverPauseOk ? onPause : undefined}
      onMouseLeave={canLoop && hoverPauseOk ? onResume : undefined}
      onFocus={canLoop ? onFocusPause : undefined}
      onBlur={canLoop ? onBlurResume : undefined}
    >
      <div
        ref={viewportRef}
        className={`${gridStyles.viewport}${isDragging ? ` ${gridStyles.viewportDragging}` : ''}`}
        tabIndex={0}
        aria-label="Банери"
        onKeyDown={(event) => {
          if (!canLoop) return
          if (event.key === 'ArrowRight') {
            event.preventDefault()
            goNext()
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault()
            goPrev()
          }
        }}
      >
        <div className={gridStyles.track} style={trackStyle}>
          {trackBanners.map((banner) => (
            <div key={banner.slotKey} className={gridStyles.slide}>
              <HeroBannerTile banner={banner} />
            </div>
          ))}
        </div>
      </div>

      {canLoop ? (
        <div className={gridStyles.nav}>
          <button type="button" className={gridStyles.arrow} aria-label="Попередній банер" onClick={goPrev}>
            <Icon name="angle-left" weight="light" />
          </button>
          <div className={gridStyles.dots} role="tablist" aria-label="Банери">
            {banners.map((banner, dotIndex) => (
              <button
                key={`dot-${banner.id}`}
                type="button"
                className={gridStyles.dot}
                aria-label={`Показати банер ${dotIndex + 1}`}
                aria-current={dotIndex === index ? 'true' : undefined}
                onClick={() => goTo(dotIndex)}
              />
            ))}
          </div>
          <button type="button" className={gridStyles.arrow} aria-label="Наступний банер" onClick={goNext}>
            <Icon name="angle-right" weight="light" />
          </button>
        </div>
      ) : null}
      {canLoop ? (
        <p className={gridStyles.srOnly} aria-live="polite">
          {`Банер ${index + 1} з ${count}`}
        </p>
      ) : null}
    </div>
  )
}

export default HeroCarouselFrame
